import { Action } from 'shared/interface';
import { DictionaryRecordType } from '../interface';

export const NAMESPACE = 'dictionaries';

export type DictionaryRecordContent = Record<number, string>;

export type DictionariesState = Record<DictionaryRecordType, DictionaryRecordContent>;

export enum ActionType {
	SET_DICTIONARY = 'SET_DICTIONARY',
}

export interface SetDictionaryPayload {
	recordType: DictionaryRecordType;
	recordContent: DictionaryRecordContent;
}

export type DictionariesActions = Action<ActionType.SET_DICTIONARY, SetDictionaryPayload>;
